import { defineSlotRecipe } from '@chakra-ui/react';

import { blockElementSlots } from '~/core/shared/config';

const plain = {
  box: {
    border: 'none',
  },
  contentBox: {
    bgColor: 'white',
    px: 0,
  },
  contentElement: {
    w: 'auto',
  },
  headerBox: {
    bgColor: 'white',
    px: 0,
  },
};

export default defineSlotRecipe({
  slots: blockElementSlots,
  base: {
    box: {
      border: '1px solid',
      borderColor: '#E2E8F0',
      mb: 12,
    },

    contentBox: {
      bgColor: 'gray.50',
      p: 6,
      pb: 0,
    },

    contentElement: {
      mb: 4,
      mr: 4,
      w: '15%',
    },

    headerBox: {
      bgColor: '#EDF2F7',
      borderBottom: '1px solid',
      borderBottomColor: '#E2E8F0',
      p: 6,
    },

    headerText: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
  },
  variants: {
    variant: {
      plain,
      'plain-slim': {
        ...plain,
        box: {
          ...plain.box,
          mb: 4,
        },
        contentElement: {
          ...plain.contentElement,
          mb: 4,
        },
      },
    },
  },
});
